<script setup lang="ts">
import useHealthcenterAdvantages from "@/advantage/composables/useHealthcenterAdvantages";
import {storeToRefs} from "pinia";
import TrialStatusContainer from "@/trial/components/trial-status/TrialStatusContainer.vue";
import {useSubscriptionPlanStore} from "@/stores/subscription-plan.store";
import MarkdownView from "@/core/components/markdown/Markdown.vue";
import Icon from "@/core/components/icon/Icon.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import {useRouter} from "vue-router";
import SubscriptionPlanService from "@/subscription-plan/services/SubscriptionPlanService";
import {computed} from "vue";

const router = useRouter();
const {globalPlan} = storeToRefs(useSubscriptionPlanStore());
const {data, isLoading} = useHealthcenterAdvantages();

/**
 * Determine if the global plan has an active subscription
 */
const hasPreviouslySubscribed = computed(() => {
    if (!globalPlan.value) {
        return false;
    }

    return SubscriptionPlanService.hasPreviouslySubscribed(globalPlan.value);
});

const navigateToGlobalPlan = () => {
    router.push({name: 'subscription-plans'});
};
</script>

<template>
  <TrialStatusContainer v-if="!hasPreviouslySubscribed">
    <template #headline>
      <BaseFlexSpinner v-if="isLoading" />
      <div v-else class="space-y-2">
        <div v-for="advantage in data" :key="advantage.id" class="flex items-baseline">
          <p class="text-xl">🎁</p>
          <MarkdownView
            :content="advantage.sales_pitch" class="text-primary font-bold text-lg"
            :inherit-styles="true"
          />
        </div>
        <div class="flex flex-row justify-end">
          <BaseButton primary @click="navigateToGlobalPlan">
            <Icon name="mdi-crown" class="mr-1" color="secondary" :size="30" />
            Passer premium
          </BaseButton>
        </div>
      </div>
    </template>
  </TrialStatusContainer>
</template>
